// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import analytics from 'util/analytics';
// import "./ClassCheckout.scss";
import { getGiftcardCheckout } from 'util/api/CheckoutAPI'
import { SET_WIDGET_STRIPE_ACCOUNT } from 'store/reducers/widgetReducer'
import { useAuth } from 'util/auth'
import {LoginSignupForm} from 'components/AccountButton'
import { checkoutGiftCard } from 'util/api/CheckoutAPI'
import CardSection from 'components/CardSection'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import PaymentMethodSelector from 'components/PaymentMethodSelector'
import CheckoutPricingSection from 'components/CheckoutPricingSection'
import {Helmet} from 'react-helmet'
import {ExpandableTerms} from 'components/ClassCheckout'
import PreviewImage from 'components/PreviewImage'
// import './offeringCheckout.scss'
import {sendNewError} from 'util/slackbot'
import OfferingSelector from 'components/OfferingSelector'
import {calculateDiscountFrom} from 'components/CheckoutPricingSection'
import {symbolFromCurrency} from 'components/PartnerInfoForm'
import {validateEmail} from 'util/auth'
import GIFT_IMAGE from "assets/img/GivingYouHealthCard.png"
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 
// var htmlInput = '<div><h1>Title</h1><p>A paragraph</p></div>';

function GiftCardCheckout(props) {

    const auth = useAuth()
    const stripe = useStripe()
    const elements = useElements()
    const dispatch = useDispatch()
    // const [takeonfee, settakeonfee] = useState(true);
    // const [marketingEmails, setMarketingEmails] = useState(true);
    // const [agreeToTerms, setAgreeToTerms] = useState(false);
    
    const stripeAccountId = useSelector(state => state.widget.stripeAccount) // JARCH Stripe account
    const [isLoading, setIsLoading] = useState(false)
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
    // const [selectedPricingOption, setSelectedPricingOption] = React.useState(null)
    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const offeringId = props.match.params.platformID ?? props.challengeId
    // console.log("offering match: ", props.match.params)

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today]',
            nextDay : '[Tomorrow]',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    // var selectedOffering = useSelector(state => state.widget.offerings?.find(val => val.id === offeringId));
    // const [apiOffering, setApiOffering] = React.useState(null)
    // if (apiOffering) {
    //     selectedOffering = apiOffering
    // }
    const selectedInstructor = useSelector(state => state.widget.instructor);
    useEffect(() => {
        analytics.page({
            title: 'Gift Card Checkout'
        })
        // analytics.track("Pre Purchase Viewed", {...selectedOffering})
    }, [])

    
    // const [userCouponCode, setUserCouponCode] = React.useState(null)
    // const handleCouponCodeChange = (couponCode) => {
    //     setUserCouponCode(couponCode)
    // }
    const [payment, setPayment] = useState(50);
    const [recipientName, setRecipientName] = useState("");
    const [recipientEmail, setRecipientEmail] = useState("");
    const [giftMessage, setGiftMessage] = useState();
    const [checkoutModel, setCheckoutModel] = React.useState({}) // JARCH: drop-in, class pack, etc.. gift
    const [checkoutData, setCheckoutData] = React.useState(null) // data from checkout
    useEffect(() => {
        const checkoutModel = {
            dropIn: false,
            payment: Number(payment),
            takeOnFee: true,
            type: "gift",
            gift: {
                payment: Number(payment),
                recipientName: recipientName,
                recipientEmail: recipientEmail,
                giftMessage: giftMessage,
            }
        }
        setCheckoutModel(checkoutModel)

    }, [payment, recipientName, recipientEmail, giftMessage]);

    useEffect(() => {
        if (!selectedInstructor.id) {
            return
        }
        setIsLoading(true)
        getGiftcardCheckout(selectedInstructor.id)
            .then(data => {
                setIsLoading(false)
                if (data?.success === false) {
                    console.log("Error fetching checkout: ", data)
                    if (data?.message) {
                        window.alert(data.message)
                    }
                    return
                }
                dispatch({type: SET_WIDGET_STRIPE_ACCOUNT, stripeAccount: data?.stripeAccount})
                // console.log(data)
                setCheckoutData(data)
            })
            .catch(err => {
                setIsLoading(false)
                console.log("Error fetching checkout: ", err)
            })
        // getOfferingCheckout(offeringId, userCouponCode)
        //     .then(data => {
        //         setIsLoading(false)
                // if (data?.success === false) {
                //     console.log("Error fetching checkout: ", data)
                //     if (data?.message) {
                //         window.alert(data.message)
                //     }
                //     return
                // }
                // // console.log(data)
                // setCheckoutData(data)
        //         if (data.offering) {
        //             setApiOffering(data.offering)
        //             const offeringModel = {
        //                 dropIn: false,
        //                 offeringId: data.offering.id,
        //                 type: data.offering.type,
        //                 payment: Number(data.offering.price),
        //                 promoCode: data.offering.promoCode,
        //                 promoCodePurchaseOnly: data.offering.promoCodePurchaseOnly ? true : false,
        //                 dollarDiscount: Number(data.offering.dollarDiscount),
        //                 offering: {
        //                     ...data.offering
        //                 }
        //             }
        //             if (data.offering?.frequency !== "subscription") {
        //                 // Disable purchasing the original
        //                 setCheckoutModel(offeringModel)
        //             }
        //         }
        //     })
        //     .catch(err => {
                // setIsLoading(false)
                // // if (err.message)
                // console.log("Error fetching checkout: ", err)
        //     })
    }, [auth, selectedInstructor.id])

    var viewModel = {}
    if (true) {
        // const reactElement = selectedOffering.descriptionHTML ? htmlToReactParser.parse(selectedOffering.descriptionHTML) : null;

        // var selectedPrice = selectedOffering.price

        // if (selectedPricingOption) {
        //     selectedPrice = selectedPricingOption.price
        // }

        // if (checkoutModel) {
        //     selectedPrice = checkoutModel.payment
        // }

        

        var selectedPrice = checkoutModel.payment
        viewModel = {
            // promoCodePurchaseOnly: selectedOffering.promoCodePurchaseOnly ? true : false,
            // userCouponCode: userCouponCode,
            // platformID: selectedOffering.platformID,
            // name: selectedOffering.name,
            // image: (selectedOffering.images && selectedOffering.images.length > 0) ? selectedOffering.images[0] : "",
            instructorName: selectedInstructor.firstName,
            showPayment: true,
            payment: selectedPrice,
            nextbuttonstring: "Purchase",
            disableButton: !checkoutData,
            isPurchasable: true,
            // specialOfferingPricingText: specialOfferingPricingText,
            // showMarketingOptIn: checkoutData?.showMarketingOptIn
        }
    }

    console.log("VIEW MODEL: ", viewModel)
    
    const { history, match } = props;

    function nextButtonClicked() {
        console.log("clicked next")
        // console.log(viewModel)
        if (!auth.userData) {
            window.alert("Must be logged in to buy this gift")
            return
        }

        const dataToCheckout = {
            ...viewModel,
            ...checkoutModel,
            partnerId: (' ' + selectedInstructor.id).slice(1)
        }

        // console.log(dataToCheckout)
        // window.alert("Wahoo!")
        checkoutHandler(dataToCheckout)
    }

    
    async function checkoutHandler(val) {

        // console.log("checkout handler: ", val)
        // return

        // if (viewModel.promoCodePurchaseOnly && userCouponCode !== selectedOffering.promoCode) {
        //     window.alert("Incorrect promo code")
        //     return
        // }

        // if (viewModel.promoCodePurchaseOnly) {
        //     val.payment = 0
        // }

        if (!val.payment) {
            window.alert("Must select price greater than zero")
            return
        }

        if (!val.gift) {
            window.alert("Must fill out all fields")
            return

        }

        if (!val?.gift?.payment || !val?.gift?.recipientName || !val?.gift?.recipientEmail || !val?.gift?.giftMessage) {
            window.alert("Must fill out all fields")
            return
        }

        if (!validateEmail(val.gift.recipientEmail)) {
            window.alert("Please enter a valid email address")
            return
        }

        // console.log("checkout: ", val)
        // return
        setIsLoading(true)
        try {

            let paymentMethod = selectedPaymentMethod?.id
            if (val.payment > 0) {
                
                if (!selectedPaymentMethod) { // requires payment with new card

                    const cardElement = elements.getElement(CardElement);

                    const paymentMethodReq = await stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement
                    }, {
                        stripeAccount: stripeAccountId
                    })

                    // console.log("paymentMethodReq: ", paymentMethodReq)

                    if (paymentMethodReq.error?.message) {
                        
                        await sendNewError(JSON.stringify({
                            error: paymentMethodReq.error.message,
                            location: "Creating payment method -- Offering checkout",
                            code: paymentMethodReq.error.code,
                            decline_code: paymentMethodReq.error.decline_code,
                            user: auth?.userData?.email,
                            host_name: selectedInstructor?.firstName,
                            offeringId: offeringId
                        }))
                        setIsLoading(false)
                        window.alert(paymentMethodReq.error.message)
                        return
                    }
                    
                    paymentMethod = paymentMethodReq?.paymentMethod?.id

                    if (val.type === "subscription") {
                        // setup card for future use.. 
                        //      Done server side
                    }
                }

            }
            

            var data = {
                ...val,
                // name: val.name,
                // description: `Class with ${val.instructorName}\n${val.timeString}`,
                // images: val.images,
                // runningTotal: Math.round(val.runningTotal * 100),
                paymentMethod: paymentMethod,
                // willTakeOnPayment: val.takeonfee,
                // agreeToBeContacted: val.marketingOptIn,
                userID: auth.userData.platformID,
                id: val.platformID,
                bookingType: "gift",
                collection: "coupons",
                bookingLocation: "widget",
                // success_url: `${process.env.REACT_APP_BOOKING_SUCCESS_URL}${match.url}/confirm/${val.platformID}`,
                // cancel_url: `${process.env.REACT_APP_BOOKING_CANCEL_URL}${match.url}/checkout/${val.platformID}`,
                customer_name: auth.userData.firstName,
                customer_email: auth.userData.email
            }



            // console.log("checkout data: ", data)
            // return


            delete data.descriptionHTML

            // return 
            const response = await checkoutGiftCard(selectedInstructor.id, data)
            if (!response.success) {
                await sendNewError(JSON.stringify({
                    error: response,
                    user: auth?.userData?.email,
                    host_name: selectedInstructor?.firstName,
                    offeringId: offeringId
                }))
                setIsLoading(false)
                if (response.message?.raw?.message) {
                    window.alert(response.message.raw.message)
                } else {
                    window.alert(response.message)    
                }
                
                return
            }

            const {sessionId, message, reservationId, connectAccountId, clientSecret} = response;

            if (sessionId) {
                setIsLoading(false)
                window.alert("We shouldn't be using sessionId anymore.. ")

            } else if (clientSecret) {

                const confirmedCardPayment = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: paymentMethod,
                    setup_future_usage: "off_session"
                }, {
                    stripeAccount: stripeAccountId
                })

                
                setIsLoading(false)
                if (confirmedCardPayment.error) {
                    console.log(confirmedCardPayment)
                    await sendNewError(JSON.stringify({
                        message: confirmedCardPayment.error.message,
                        user: auth?.userData?.email,
                        host_name: selectedInstructor?.firstName,
                        offeringId: offeringId
                    }))
                    setIsLoading(false)
                    if (confirmedCardPayment.error.decline_code === 'do_not_honor') {
                        window.alert("Your card was declined due to the error `Do hot honor`. Please contact your bank to approve this charge and try again or use another card.")
                    } else {
                        window.alert(confirmedCardPayment.error.message)
                    }
                    
                    return
                }
                
                handleSuccessfulPayment(data, reservationId, response?.couponCode)
            } else if (reservationId) {
                setIsLoading(false)
                handleSuccessfulPayment(data, reservationId, response?.couponCode)
            } else if (message) {
                setIsLoading(false)
                window.alert(message)
            } else {
                setIsLoading(false)
                window.alert("Something went wrong after succesful api response")
            }
        } catch (err) {
            setIsLoading(false)
            console.log("wuh oh")
            console.log(err)
            if (err.message) {
                window.alert(err.message)
            } else {
                window.alert(err)
            }
        }
    }

    function handleSuccessfulPayment(data, resId, couponCode) {

        analytics.track('Purchase', {
            pixelId: selectedInstructor?.instructorProfile?.facebookPixelId,
            value: data.payment,
            name: data.name,
            offeringId: data.id,
            currency: 'USD',
            location: 'GiftCardCheckout',
            type: data.type, // pack, dropin, subscription
            offering: data.name
        })

        if (couponCode) {
            setSuccessCouponCode(couponCode)
        }

        // const {match} = props
        // console.log("match: ", match)
        // var URL =  match.url.replace("checkout", "confirm")
        // if (resId) {
        //     URL = URL + `?reservation_id=${resId}`
        // }
        // console.log("match: ", URL)
        // history.push(URL)
    }

    // const [successCouponCode, setSuccessCouponCode] = React.useState("jj39-dj39")
    const [successCouponCode, setSuccessCouponCode] = React.useState(null)

    // const submit = (event) => {
    //     event.preventDefault();
    //     nextButtonClicked();
    // }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (
    <div className="container">
        <Helmet>
            <title>{"Gift Card"}</title>
        </Helmet>
        {(!successCouponCode) ? (
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6"> 
                    <PreviewImage className="mb-4" imageUrl={GIFT_IMAGE} />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    
                    <LoginSignupForm
                    mode={'signin'}
                    onComplete={() => "Logged in successfully"}
                    titleCopy="Login for access"
                    />
                    <hr/>

                    <label>To</label>
                    <div className="input-group mb-3">
                        <input value={recipientName} onChange={(e) => setRecipientName(e.target.value)} placeholder={"Recipient name"} type="name" className="form-control" aria-label="Full name"/>
                    </div>
                    <div className="input-group mb-3">
                        <input value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} placeholder={"Recipient email"} type="email" className="form-control" aria-label="Full name"/>
                    </div>
                    <div className="input-group mb-3">
                        <textarea value={giftMessage} onChange={(e) => setGiftMessage(e.target.value)} placeholder={"Gift message"} type="text" className="form-control" aria-label="Full name"/>
                    </div>

                    <label>Choose a gift card amount</label>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text">{symbolFromCurrency(currency)}</span>
                        </div>
                        {/* defaultValue={payment} */}
                        <input value={payment} onChange={(e) => setPayment(e.target.value)} placeholder={"Enter gift amount"} type="number" className="form-control" aria-label="Amount (to the nearest dollar)"/>
                        <div className="input-group-append">
                            <span className="input-group-text">.00</span>
                        </div>
                    </div>

                    <hr/>

                    {viewModel.showPayment && checkoutData?.paymentMethods && (
                        <Form.Group>
                            <PaymentMethodSelector
                            {...checkoutData}
                            paymentMethods={checkoutData.paymentMethods}
                            // onChange={(model) => console.log(`got the model: ${model}`)}
                            onChange={(model) => {
                                console.log(model)
                                setSelectedPaymentMethod(model)
                            }}
                            />
                        </Form.Group>
                    )}
                    {viewModel.showPayment && !selectedPaymentMethod && (
                        <CardSection className="w-100 mb-5" />
                    )}

                    {checkoutData && checkoutModel && (
                        <CheckoutPricingSection
                        checkoutData={checkoutData}
                        checkoutModel={checkoutModel}
                        // handleCouponCodeChange={handleCouponCodeChange}
                        // handleCouponCodeApply={handleCouponCodeApply}
                        isLoading={isLoading}
                        // handlePricingOptionChange={(model) => setSelectedPricingOption(model)}
                        />
                    )}
                    
                    <div className="d-flex flex-row justify-content-center">
                        {viewModel.isPurchasable ? (
                            <Button disabled={isLoading || viewModel.disableButton} onClick={() => nextButtonClicked()} style={{width: "50%"}} className="primaryColor my-4" variant="primary">
                                {viewModel.nextbuttonstring}
                                {isLoading && (
                                    <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                >
                                    <span className="sr-only">Sending...</span>
                                </Spinner>

                                )}
                            </Button>
                        ) : (
                            <div className=" text-center my-3">
                                {/* This offering cannot be purchased. You either already own this offering, or it can only be used by first time clients. */}
                            </div>
                        )}
                    </div>
                </div>

                
            </div>
        ) : (
            // <div className='align-self-stretch container text-center my-auto pt-5'>
            <div className="col-sm-12 col-md-6 col-lg-6 mx-auto text-center">
                <PreviewImage className="mb-4" imageUrl={GIFT_IMAGE} />
                <h2>Congrats!</h2>
                <h4>You've purchased a ${payment} gift card for {recipientEmail}</h4>
                <h3>{successCouponCode}</h3>
                <p>For use on any purchase at sutrapro.com/{selectedInstructor.widgetName}</p>
            </div>
        )}
    </div>
    );
}

export default GiftCardCheckout;
